import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import TransitionPage from 'containers/TransitionPage'
import BackButton from 'components/atoms/buttons/BackButton'
import CreateOrganisationForm from 'components/organisms/CreateOrganisationForm'

export const styles = theme => ({
  root: {
    width: 328,
    margin: '0 auto',
    ...theme.components.accountPage,
  },
  title: {
    marginBottom: theme.spacing(4),
  },
  logo: {
    marginBottom: theme.spacing(6),
  },
  backButton: {
    ...theme.components.backButton,
  },
})

const EnterEmail = ({
  classes,
  errorMessage,
  onFormSubmit,
  hasError,
  onBackPress,
}) => (
  <TransitionPage>
    <div className={classes.root}>
      <Typography variant="h1" className={classes.title}>
          Create a project
      </Typography>
      <CreateOrganisationForm
        onFormSubmit={onFormSubmit}
        apiCallError={hasError}
        errorMessage={errorMessage}
      />
      <BackButton className={classes.backButton} onPress={onBackPress} />
    </div>
  </TransitionPage>
)

EnterEmail.propTypes = {
  hasError: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  onBackPress: PropTypes.func,
  onFormSubmit: PropTypes.func,
  errorMessage: PropTypes.string,
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(EnterEmail)



// WEBPACK FOOTER //
// ./src/containers/organisation/CreateOrganisation/CreateOrganisation.js